export default {
  App: {
    title: '信息互联，从me开启'
  },
  // views/logic/homePage/index.vue
  loigcHomePageIndex: {
    // 申请试用联系我们的两个小模块
    applyForTrial: 'Apply',
    contactUs: 'contact',
    // 轮播图下方显示的4个小模块
    pictureSuspensionTitle1: 'Fast self built interface',
    pictureSuspensionData1: 'Quickly build its own external interface without changing the existing system and realize opening and connection to the outside world',
    pictureSuspensionTitle2: 'Multi data specification integration',
    pictureSuspensionData2: 'Eliminate specification differences between data platforms to achieve unified, efficient and orderly data specifications',
    pictureSuspensionTitle3: 'Multi platform information interconnection',
    pictureSuspensionData3: 'Open the platform barrier and realize information interconnection through active or passive calling methods of the interface',
    pictureSuspensionTitle4: 'Information interconnection, the general rule is not painful',
    pictureSuspensionData4: 'Improve the interaction efficiency between enterprise systems, make the information flow efficiently, reduce the crux and eliminate the pain points',
    // 热门应用
    popularApplicationsTitle: 'Safe, credible and continuously innovative products and services',
    popularApplicationsButton: 'Apply for trial',
    //解决方案
    successSwitchTitle: 'Recommended solution',
    successSwitchButtonText: 'View all schemes',
    // 解决方案第一部分
    bankEnterpriseInterconnection: {
      label: 'Bank enterprise interconnection',
      title1: 'Secure bank enterprise direct connection solution',
      data1: 'The client installed on the customer\'s special financial computer regularly patrols the middleware service, obtains the payment and other instructions of the business system, decrypts and executes the corresponding bank operations through the preset password, so as to achieve the effect of direct connection between the business and the bank. The scheme has no potential security risks, the instructions are encrypted in the whole process of transmission, and the client is installed on the intranet computer, so there is no risk of external network exposure. The instruction execution results are fed back to the business system regularly, and the whole process is recorded and documented.',
      title2: 'Corresponding bank',
      buttonText: 'Apply for trial',
    },
    // 解决方案第二部分
    systemInterconnection: {
      label: 'OA system interconnection solution',
      title1: 'OA system interconnection solution',
      data1: 'Through middleware, the interfaces between multiple OA systems and business systems are opened up to realize the interconnection of a set of interfaces of multiple OA systems.',
      title2: 'Corresponding OA system',
      dingding: '钉钉',
      feishu: '飞书',
      qiyeweixin: '企业微信',
      buttonText: 'Apply for trial'
    },
    // 解决方案第三部分
    controlSystemInterconnection: {
      label: 'Cost control system interconnection',
      title1: 'Cost control system interconnection solution',
      data1: 'Through middleware, the interface between multiple expense guarantee and control systems and business systems is opened, and the interconnection of a set of interfaces of multiple expense control systems is realized.',
      title2: 'Corresponding fee control system',
      buttonText: 'Apply for trial'
    },
    // 成功客户
    focusOnCustomers: {
      title: 'Focus on customer success',
      buttonText: 'See more',
    },
    // 最下方备注
    fonterTitle: 'Copyright©2022 云科同创(武汉)信息科技有限公司',
    // JS
    rules: {
      phoneCannotNull: 'Mobile phone number cannot be empty',
      inputSuccessPhone: 'Please enter the correct mobile phone number',
      inputSuccessEmail: 'Please fill in the email correctly',
      inputEffectiveEmail: 'Please enter a valid email address',
      nameRule: 'Please enter a name',
      emailRule: 'Please enter email address',
      phoneRule: 'Please enter your mobile number'
    },
    // 热门应用
    popularApplicationsList: {
      data1: {
        title: 'OA system',
        data1: {
          title: 'Enterprise wechat direct connection',
          smallTitle: 'Integrated application of OA and other functions of enterprise wechat and business system',
          data: ' The OA related documents in the enterprise wechat are seamlessly connected with the business system, which not only makes use of the convenient functions of the mobile terminal, but also connects with the business system to realize the information accompanying of anytime, anywhere and anydevice. '
        },
        data2: {
          title: 'DingDing direct connection',
          smallTitle: 'Integrated application of nailing approval function and business system',
          data: ' Seamlessly connect nailing\'s powerful approval function with the business system。 '
        },
        data3: {
          title: 'Flying book direct link',
          smallTitle: 'Integrated application of OA and other functions of flying book and business system',
          data: ' The OA related documents in the flybook are seamlessly connected with the business system, which not only makes use of the convenient functions of the mobile terminal, but also connects with the business system to realize the information accompanying of anytime, anywhere and anydevice。 '
        },
        data4: {
          title: 'Lark direct',
          smallTitle: 'Integrated application of overseas flying Book lark\'s OA and other functions and business systems',
          data: 'The OA related documents in the overseas flying Book lark are seamlessly connected with the business system, which not only makes use of the convenient functions of the mobile terminal, but also connects with the business system to realize the information accompanying of anytime, anywhere and anydevice。 '
        }
      },
      data2: {
        title: 'Cost system',
        data1: {
          title: 'Easy Express',
          smallTitle: 'Integrated application of easy express and business system',
          data: 'The integrated application of expense reimbursement system and business system. The application provides a unified interface for business system, which is configurable and easy to maintain。'
        },
        data2: {
          title: 'Huilianyi',
          smallTitle: 'Integrated application of huilianyi and business system',
          data: ' Expense reimbursement system is the integrated application of Yihui Lianyi and business system. The application provides a unified interface for business system, which is configurable and easy to maintain。 '
        }
      },
      data3: {
        title: 'OMS',
        data1: {
          title: 'Guan Yiyun',
          smallTitle: 'The application of direct connection between Guanyi cloud OMS and business system',
          data: 'The application of direct connection between Guanyi cloud OMS and business system. For the business system, it provides a unified interface for business documents, which is configurable and easy to maintain. '
        },
        data2: {
          title: 'Yi Cang',
          smallTitle: 'Application of direct connection between e-warehouse OMS and business system',
          data: ' The application of direct connection between e-warehouse OMS and business system. For the business system, it provides a unified interface for business documents. This interface is configurable and easy to maintain。 '
        }
      },
      data4: {
        title: 'E-commerce platform'
      }
    },
    // 轮播图上显示的信息
    lunboImage1: {
      topLeftData: 'Interworking and interchange',
      topRightData: 'Smart data',
      h1Data: 'Open up the two channels of enterprise appointment and supervision, and realize the rapid flow of data',
      pData: 'Help enterprises quickly break through the information barriers between systems, and realize high-speed interoperability and data exchange between different systems, stable and efficient processing and analysis'
    },
    lunboImage2: {
      topLeftData: 'Normative and orderly',
      topRightData: 'Smart data',
      h1Data: 'Unify data specifications to achieve standardized and orderly data',
      pData: 'Help enterprises unify data interface specifications, make data come and go in an orderly manner, and make every node of enterprise operation data process and analyze efficiently, orderly, stably and efficiently'
    },
  },
  // views/logic/contanctUs/index.vue 联系我们页面
  loigcContactUsIndex: {
    title: 'contact us',
    showData: 'The pre-sales team provides you with pre-sales consultation, product and solution recommendation, configuration recommendation and other services to help you open the Internet and smooth information!',
    formName: 'name',
    formEmail: 'E-mail',
    formCorporateName: 'corporate name',
    formPosition: 'position',
    formPhone: 'phone',
    formTextArea: 'Consultation content',
    buttonSubmit: 'Submit',
    // 下方备注
    fonterTitle: 'Copyright©2022 云科同创(武汉)信息科技有限公司',
    // JS
    subject: '云直连-产品-联系我们-邮件',
    sendSuccessTip: 'Sent successfully',
  },
  // components/topBar/index.vue
  baseSwiperIndex: {
    connectUsTitle: 'contact us',
    register: 'register',
    welcomeWord: 'welcome',
    // JS
    showCenterDataList1: 'scenario',
    showCenterDataList2: 'Popular',
    showCenterDataList3: 'Solution',
    showCenterDataList4: 'Successful',
    console: 'Console',
    signOut: 'sign out',
    login: 'login'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js